module.exports = __webpack_public_path__ + "img/deezer.1b7ac879.png";